'use strict';
/**
 * A side slider list of activities
 */

angular.module('youth').directive('namevatar', function () {
  return {
    restrict: 'AC',
    scope: {
      userId: '=namevatar'
    },
    link: function link(scope, element) {
      /**
       * This generates a random number based on a seed. The same seed should always produce the same random number.
       * @param  {int} seed The seed to use in the random number generation
       * @return {number}   A random number, between 0 and 1.
       */
      function hash(seed) {
        var x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
      }
      /**
       * Get the colour luminance
       * @param  {number} seed The see to generate the luminance. The same seed will always generate the same luminance
       * @param  {number} val  The lightness of the color to generate
       * @return {string}      A hsla string
       */
      function colorLuminance(seed, val) {
        var r = hash(seed);
        var g = hash(r);
        var b = hash(g);
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var chr = max - min;
        var hue = 0;
        if (r === max) {
          hue = 60 * ((g - min - (b - min)) / chr);
          if (hue < 0) {
            hue += 360;
          }
        } else if (g === max) {
          hue = 120 + 60 * ((b - min - (r - min)) / chr);
        } else if (b === max) {
          hue = 240 + 60 * ((r - min - (g - min)) / chr);
        }
        return 'hsla(' + Math.floor(hue) + ',' + '40%,' + val + '%,1)';
      }
      /**
       * Get a CSS blob for this avatar
       *
       * @param  {number} seed  the seed to use to generate the CSS
       * @param  {color} color1 first color to use
       * @param  {color} color2 second color to use
       * @return {object}       a css object
       */
      function getCss(seed, color1, color2) {
        var styles = [{
          'background-image': 'linear-gradient(to right,' + color1 + ' 50%,' + color2 + ' 50%,' + color2 + ' 100%)',
          'background-size': '.5rem .5rem'
        }, {
          'background-image': 'radial-gradient(circle closest-side at 30% 30%,' + color1 + ' 90%,' + color2 + ' 94%,' + color2 + ' 100%)',
          'background-size': '1em 1em'
        }, {
          'background-image': 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%)',
          'background-size': '1.5rem 1.5rem'
        }, {
          'background-image': 'linear-gradient(45deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%),' + 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%)',
          'background-size': '1.5rem 1.5rem'
        }, {
          'background': 'linear-gradient(115deg,' + color1 + ' 75%, ' + color2 + ' 75%) 0 0,' + 'linear-gradient(245deg,' + color1 + ' 75%, ' + color2 + ' 75%) 0 0,' + 'linear-gradient(115deg,' + color1 + ' 75%, ' + color2 + ' 75%) .5rem -1rem,' + 'linear-gradient(245deg,' + color1 + ' 75%, ' + color2 + ' 75%) .5rem -1rem',
          'background-size': '1rem 2rem'
        }, {
          'background': 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%) -.5em 0,' + 'linear-gradient(225deg,' + color1 + ' 25%, ' + color2 + ' 25%) -.5em 0,' + 'linear-gradient(315deg,' + color1 + ' 25%, ' + color2 + ' 25%),' + 'linear-gradient(45deg,' + color1 + ' 25%, ' + color2 + ' 25%)',
          'background-size': '1rem 1rem'
        }, {
          'background-color': 'red',
          'background': 'radial-gradient(circle at 100% 50%,' + color1 + ' 20%,' + color2 + ' 21%,' + color2 + ' 34%, ' + color1 + ' 35%,' + color1 + '),' + 'radial-gradient(circle at 0% 50%,' + color1 + ' 20%,' + color2 + ' 21%,' + color2 + ' 34%, ' + color1 + ' 35%,' + color1 + ') 0 -1rem',
          'background-size': '1.5rem 2rem'
        }, {
          'background': 'linear-gradient(45deg,' + color1 + ' 25%, ' + color2 + ' 25%,' + color2 + ' 75%,' + color1 + ' 75%, ' + color1 + '),' + 'linear-gradient(-45deg,' + color1 + ' 25%, ' + color2 + ' 25%,' + color2 + ' 75%,' + color1 + ' 75%, ' + color1 + ')',
          'background-size': '1rem 1rem'
        }, {
          'background-image': 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%)',
          'background-size': '1.5rem 1.5rem'
        }, {
          'background-image': 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%)',
          'background-size': '1.5rem 1.5rem'
        }, {
          'background-image': 'linear-gradient(135deg,' + color1 + ' 25%, ' + color2 + ' 25%, ' + color2 + ' 50%, ' + color1 + ' 50%, ' + color1 + ' 75%, ' + color2 + ' 75%, ' + color2 + ' 100%)',
          'background-size': '1.5rem 1.5rem'
        }];
        return styles[Math.floor(hash(seed) * 10)];
      }

      scope.$watch('userId', function () {
        if (!scope.userId) {
          // if there's not a property to use, move on
          return;
        }

        var color1 = colorLuminance(scope.userId, 70);
        var color2 = colorLuminance(scope.userId, 60);
        var color3 = colorLuminance(scope.userId, 50);
        element.css('background-color', color1);
        element.css('border-color', color3);

        element.css(getCss(scope.userId, color1, color2));
      });
    }
  };
});